import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/timesheets/UserLeaveProperties.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import {
  __,
  convertHoursAndMinutesToMinutes,
  convertMinutesToHoursAndMinutes,
  mapStateToProps,
  validateForm,
} from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import autobind from 'autobind-decorator';
import classNames from 'classnames';
import {
  listTimesheets,
  editUserLeave,
} from '../../redux/actions/table/timesheets';
import EditUserLeaveForm from '../../forms/timesheets/EditUserLeaveForm';

@mapStateToProps((state) => ({
  auth: state.auth,
}))
@withRouter
class UserLeaveProperties extends Component {
  @autobind
  _handleSubmit(formData) {
    const { user_id, leave_uuid, minutes } = this.props.data;
    const all_day = !minutes;

    formData = {
      ...formData,
      user_id,
      reason: formData?.leave_reason_id || '',
      description: formData?.description || '',
      approvers: _.map(formData.approvers, 'id'),
      followers: _.map(formData.followers, 'id'),
      ...(all_day
        ? {
            start_time: formData?.date?.start,
            end_time: formData?.date?.end,
            minutes: null,
            date: null,
          }
        : {
            date: formData.date,
            minutes: convertHoursAndMinutesToMinutes(
              formData?.hours,
              formData?.minutes
            ),
          }),
    };

    return validateForm(
      editUserLeave(leave_uuid, formData).then(() => {
        listTimesheets();

        this.props.readAction(formData.id);

        setNotification(__('timesheets.properties.saved'));
      })
    );
  }

  render() {
    const { data, collapsed } = this.props;

    const { hours, minutes } = convertMinutesToHoursAndMinutes(data?.minutes);

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        <EditUserLeaveForm
          onSubmit={this._handleSubmit}
          initialValues={{
            ..._.pick(data, ['leave_reason_id', 'description']),
            approvers: (data.approvers || []).map((approver) => ({
              ...approver,
              name: approver?.fullname,
            })),
            followers: (data.followers || []).map((follower) => ({
              ...follower,
              name: follower?.fullname,
            })),
            minutes: minutes,
            hours: hours,
            all_day: !data?.minutes,
            date: !data?.minutes
              ? {
                  start: data?.start_time,
                  end: data?.end_time,
                }
              : data.date,
          }}
          data={data}
        />
      </div>
    );
  }
}

export default UserLeaveProperties;
